import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/triplabo/styles/index.css';
import '@link/triplabo/i18n';
import '@link/triplabo/vendors/gtm';
import App from '@link/triplabo/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
